module.exports = __webpack_public_path__ + "static/media/Public_12.95a3249e.jpg";